export const normalizePhone = (value: string) => {
  const digits = value.replace(/\D/g, "");

  if (digits.startsWith("00961")) return digits.slice(5);
  if (digits.startsWith("961")) return digits.slice(3);
  if (digits.startsWith("0")) return digits.slice(1);

  return digits;
};

export const normalizePlate = (value: string) =>
  value.toUpperCase().replace(/[^A-Z0-9]/g, "");

export const normalizeName = (value: string) =>
  value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");

export const namesAreSimilar = (left: string, right: string) => {
  const a = normalizeName(left);
  const b = normalizeName(right);
  return Boolean(a && b && (a === b || a.includes(b) || b.includes(a)));
};
